import { AxiosAdapter } from '../../../_config/adapters/axios/axios.adapter';
import { Http } from '../../../_config/adapters/axios/axios.protocols';
import { Enviroment } from '../../../_config/constants/enviroment-v2.constant';
import { ENVIROMENT } from '../../../v2-config/constants/enviroments.constant';

export class Service {
	async getNotificationsByEmail({ email, page, seen, type }) {
		return new AxiosAdapter({
			method: Http.GET,
			url: `${Enviroment.PANEL_TRACKING}/notification/email/${email}/page/${page}`,
			params: { seen, type },
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				return e;
			});
	}

	async getNotificationsByCountry({ page, seen, token, pharmacy, type, order }) {
		console.log('page', page, 'seen', seen, 'token', token, 'pharamcy', pharmacy, 'type', type);
		return new AxiosAdapter({
			method: Http.GET,
			url: `${ENVIROMENT.NOTIFICATION_V2}/notification/country/page/${page}`,
			params: { seen, pharmacy: pharmacy, type: type, order: order },
			headers: { Authorization: `Bearer ${token}` },
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				return e;
			});
	}

	markNotificationsAsRead({ ids, token, seen }) {
		console.log('ids', ids, 'seen', seen);
		return new AxiosAdapter({
			method: Http.PUT,
			url: `${ENVIROMENT.NOTIFICATION_V2}/notification/update-many`,
			data: { ids, seen:seen },
			headers: { Authorization: `Bearer ${token}` },
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				return e;
			});
	}

	async getNotificationById(id) {
		return new AxiosAdapter({
			method: Http.GET,
			url: `${Enviroment.PANEL_TRACKING}/notification/${id}`,
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				return e;
			});
	}

	async updateNotificationById(id, body) {
		return new AxiosAdapter({
			method: Http.PUT,
			url: `${Enviroment.PANEL_TRACKING}/notification/${id}`,
			data: body,
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				return e;
			});
	}
	async updateNotifications(body) {
		return new AxiosAdapter({
			method: Http.PUT,
			url: `${Enviroment.PANEL_TRACKING}/notification/update-many`,
			data: body,
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				return e;
			});
	}
}
